import {
  formatGetHeaders, formatPostHeaders
} from '@configurations/api-configuration';
import { UserPreferencesGateway } from '@scenario/gateways/user-preferences.gateway';
import { UserPreferences } from '@scenario/models/user-preferences.model';
import { environment } from '../../../../../environments/environment';
import { UserPreferencesMapper } from './user-preferences.mapper';

export class ApiUserPreferencesGateway implements UserPreferencesGateway {
  private readonly mapper = new UserPreferencesMapper();
  private readonly userPreferencesApi = `${environment.backend_url}/api/v1/user/preference`;

  async retrieve(): Promise<UserPreferences> {
    try {
      const response = await fetch(`${this.userPreferencesApi}`, await formatGetHeaders());
      const preferences = await response.json();
      return this.mapper.mapToDomainModel(preferences);
    } catch (error) {
      throw new Error('Error retrieving user preferences: ' + error);
    }
  }

  async save(userPreferences: UserPreferences): Promise<void> {
    try {
      const response = await fetch(`${this.userPreferencesApi}`, await formatPostHeaders(userPreferences));
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving user preferences: ' + error);
    }
  }
}
